import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import bs from "./locales/bs.json";
import en from "./locales/en.json";
import countries from "i18n-iso-countries/index.js";
import enCountries from "i18n-iso-countries/langs/en.json";
import bsCountries from "i18n-iso-countries/langs/bs.json";

countries.registerLocale(enCountries);
countries.registerLocale(bsCountries);

// Locale priority:
//   1. window.__SSR__.locale  (matches server render — required for hydration parity)
//   2. localStorage           (returning user's choice on non-SSR pages)
//   3. "bs"                   (default)
const ssrLocale =
  typeof window !== "undefined" ? window.__SSR__?.locale : null;
const initialLang =
  ssrLocale ??
  (typeof localStorage !== "undefined" ? localStorage.getItem("lang") : null) ??
  "bs";

i18n.use(initReactI18next).init({
  resources: { bs: { translation: bs }, en: { translation: en } },
  lng: initialLang,
  fallbackLng: "bs",
  interpolation: { escapeValue: false },
});

export default i18n;
